import "core-js/modules/es.array.push.js";
// document.title = "绑定";
import { defineComponent, reactive, ref, onBeforeUnmount } from "vue";
import { useRouter } from "vue-router";
import { showNotify } from "vant";
import { bind, sendCode } from "@/api/my";
export default defineComponent({
  name: "Bind",
  setup() {
    console.log("bind");
    const router = useRouter();
    let modelForm = reactive({
      jobNum: "",
      phone: "",
      name: "",
      code: ""
    });
    // 校验函数返回 true 表示校验通过，false 表示不通过
    const validPhone = val => /^(?:(?:\+|00)86)?1\d{10}$/.test(val);
    const formRef = ref();
    // 倒计时定时器
    let timer = 0;
    // 验证码显示文本
    const codeText = ref("获取验证码");
    // 是否禁用验证码按钮
    const codeDisabled = ref(false);
    const getCode = async () => {
      var _formRef$value;
      await ((_formRef$value = formRef.value) === null || _formRef$value === void 0 ? void 0 : _formRef$value.validate(["name", "jobNum", "phone"]));
      sendCode(modelForm).then(res => {
        console.log(res);
        showNotify({
          type: "success",
          message: "发送成功,请注意查收短信"
        });
        let time = 60;
        timer = setInterval(() => {
          if (time == 0) {
            clearInterval(timer);
            codeText.value = "获取验证码";
            codeDisabled.value = false;
          } else {
            codeDisabled.value = true;
            codeText.value = time + "秒后重试";
            time--;
          }
        }, 1000);
      });
    };
    onBeforeUnmount(() => {
      // 卸载定时器
      if (timer) {
        clearInterval(timer);
      }
    });
    let loading = ref(false);
    const onSubmit = values => {
      loading.value = true;
      bind(values).then(({
        code,
        msg
      }) => {
        if (code === 200) {
          showNotify({
            type: "success",
            message: msg
          });
          router.push("/my");
        }
      }).finally(() => {
        loading.value = false;
      });
    };
    return {
      modelForm,
      validPhone,
      codeText,
      codeDisabled,
      formRef,
      getCode,
      loading,
      onSubmit
    };
  }
});